(function () {
  const drawer = document.getElementById('exode-cart-drawer');
  if (!drawer) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + '€';
  }

  function openDrawer() {
    drawer.hidden = false;
    drawer.classList.add('is-open');
    document.body.classList.add('exode-cart-open');
    refreshCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    document.body.classList.remove('exode-cart-open');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function updateGiftUpsell(total) {
    const gift = parseInt(drawer.dataset.giftThreshold, 10) || 6000;
    const giftRemaining = drawer.querySelector('[data-gift-remaining]');
    const giftBox = drawer.querySelector('[data-gift-upsell]');

    if (giftRemaining && total < gift) {
      giftRemaining.textContent = formatMoney(gift - total);
    }
    if (giftBox) giftBox.hidden = total >= gift;
  }

  function updateShippingBar(total) {
    const bar = drawer.querySelector('[data-shipping-bar]');
    if (!bar) return;

    const tier1 = parseInt(drawer.dataset.tier1Threshold, 10) || 0;
    const tier2 = parseInt(drawer.dataset.tier2Threshold, 10) || 0;
    const gift = parseInt(drawer.dataset.giftThreshold, 10) || 0;
    const tier1Message = drawer.dataset.tier1Message || '';
    const tier2Message = drawer.dataset.tier2Message || '';
    const tier3Message = drawer.dataset.tier3Message || '';

    let threshold = gift;
    let message = tier3Message;
    if (total < tier1) {
      threshold = tier1;
      message = tier1Message;
    } else if (total < tier2) {
      threshold = tier2;
      message = tier2Message;
    }

    const remaining = threshold - total;
    const text = bar.querySelector('[data-shipping-text]');
    if (text) {
      if (remaining > 0) {
        text.innerHTML =
          'Encore <span data-shipping-remaining>' + formatMoney(remaining) + '</span> pour ' + message;
      } else {
        text.textContent = 'Félicitations, vous avez débloqué tous les avantages !';
      }
    }

    const fill = bar.querySelector('[data-progress-fill]');
    if (fill && gift > 0) {
      let pct = (total / gift) * 100;
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;
      fill.style.width = pct + '%';
    }
  }

  function renderItems(cart) {
    const container = drawer.querySelector('[data-cart-items]');
    if (!container) return;

    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '<p class="exode-cart-drawer__empty">Votre panier est vide</p>';
      return;
    }

    container.innerHTML = cart.items
      .map((item) => {
        const variantTitle =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="exode-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
            : '';
        const image = item.image
          ? '<img src="' + item.image + '" alt="" width="60" height="60" loading="lazy">'
          : '';
        return (
          '<div class="exode-cart-drawer__item" data-line-key="' +
          item.key +
          '">' +
          '<a href="' +
          item.url +
          '" class="exode-cart-drawer__item-image">' +
          image +
          '</a>' +
          '<div class="exode-cart-drawer__item-details">' +
          '<div class="exode-cart-drawer__item-top">' +
          '<div>' +
          '<a href="' +
          item.url +
          '" class="exode-cart-drawer__item-title">' +
          escapeHtml(item.product_title) +
          '</a>' +
          variantTitle +
          '<p class="exode-cart-drawer__item-price">' +
          formatMoney(item.final_line_price) +
          '</p>' +
          '</div>' +
          '<button type="button" class="exode-cart-drawer__item-remove" data-remove-line="' +
          item.key +
          '" aria-label="Supprimer">' +
          '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" aria-hidden="true"><path d="M2 4h12M5 4V2.5A1.5 1.5 0 016.5 1h3A1.5 1.5 0 0111 2.5V4m2 0v11.5a1.5 1.5 0 01-1.5 1.5h-7A1.5 1.5 0 013 15.5V4h10zM6.5 7.5v5M9.5 7.5v5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '</div>' +
          '<div class="exode-cart-drawer__qty">' +
          '<button type="button" class="exode-cart-drawer__qty-btn" data-qty-change="-1" data-line-key="' +
          item.key +
          '" aria-label="Diminuer">−</button>' +
          '<input type="number" class="exode-cart-drawer__qty-input" value="' +
          item.quantity +
          '" min="0" data-line-key="' +
          item.key +
          '" aria-label="Quantité">' +
          '<button type="button" class="exode-cart-drawer__qty-btn" data-qty-change="1" data-line-key="' +
          item.key +
          '" aria-label="Augmenter">+</button>' +
          '</div>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  async function refreshCart() {
    try {
      const res = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      updateCount(cart.item_count);
      updateGiftUpsell(cart.total_price);
      updateShippingBar(cart.total_price);
      renderItems(cart);
      window.dispatchEvent(new CustomEvent('exode:cart:updated', { detail: cart }));
    } catch (e) {
      console.warn('Cart refresh failed', e);
    }
  }

  async function changeLine(key, quantity) {
    await fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    await refreshCart();
  }

  async function addVariant(variantId, quantity) {
    await fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    });
    await refreshCart();
    openDrawer();
  }

  // Public API (used by product.js and header)
  window.ExodeCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart,
    addVariant: addVariant,
  };

  // Open triggers
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Delegated cart actions
  drawer.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-remove-line]');
    if (removeBtn) {
      e.preventDefault();
      await changeLine(removeBtn.dataset.removeLine, 0);
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.lineKey;
      const input = drawer.querySelector('.exode-cart-drawer__qty-input[data-line-key="' + key + '"]');
      const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      await changeLine(key, next);
      return;
    }

    const addBtn = e.target.closest('[data-add-variant]');
    if (addBtn) {
      e.preventDefault();
      await addVariant(addBtn.dataset.addVariant, 1);
    }
  });

  drawer.addEventListener('change', async (e) => {
    const input = e.target.closest('.exode-cart-drawer__qty-input');
    if (!input) return;
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    await changeLine(input.dataset.lineKey, qty);
  });

  // Initial count and shipping message from page
  const initialCount = document.querySelector('[data-cart-count]');
  if (initialCount) {
    const n = parseInt(initialCount.getAttribute('data-count') || initialCount.textContent, 10) || 0;
    updateCount(n);
  }
  const initialTotal = parseInt(drawer.dataset.initialTotal, 10) || 0;
  updateGiftUpsell(initialTotal);
  updateShippingBar(initialTotal);

  // Promo code — applies via Shopify's discount redirect endpoint
  drawer.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-promo-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('.exode-cart-drawer__promo-input');
    const code = (input && input.value || '').trim();
    if (!code) return;
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
  });
})();
